module.exports = __webpack_public_path__ + "assets/ca6ac70b6d9030c7621013bb8927b985.png";